import React, { useState } from "react";
import "./Head.css";
import ScrollProgressBar from "../../../componant/ScrollProgressBar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const Head = ({ darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      localStorage.clear();
      navigate("/");
    } catch {
      navigate("/login");
    }
  };

  const hasToken = !!localStorage.getItem("authToken");

  const renderButtons = () => {
    switch (location.pathname) {
      case "/PricingCard":
        return (
          <>
            <button onClick={handleLogout} className="btn signup">
              تسجيل الخروج
            </button>
          </>
        );

      case "/ProfileCard":
        return (
          <>
            <button onClick={() => navigate("/PricingCard")} className="btn login">
              جميع المحاضرات
            </button>
            <button onClick={() => navigate("/MySubscriptions")} className="btn login">
              دروسي
            </button>
            <button onClick={handleLogout} className="btn signup">
              تسجيل الخروج
            </button>
          </>
        );

      case "/Video":
        return (
          <>
            <button onClick={() => navigate("/ProfileCard")} className="btn login">
              المحاضرات
            </button>
            <button onClick={handleLogout} className="btn signup">
              تسجيل الخروج
            </button>
          </>
        );

      case "/MySubscriptions":
        return (
          <>
            <button onClick={() => navigate("/Teachers")} className="btn login">
              مدرسيني
            </button>
            <button onClick={handleLogout} className="btn signup">
              تسجيل الخروج
            </button>
          </>
        );

      default:
        return !hasToken ? (
          <>
            <button onClick={() => navigate("/Signup")} className="btn signup">
              اعمل حساب جديد !
            </button>
            <button onClick={() => navigate("/Login")} className="btn login">
سجل دخولك
            </button>
          </>
        ) : (
          <>
            <button onClick={() => navigate("/MySubscriptions")} className="btn login">
              دروسي
            </button>
            <button onClick={handleLogout} className="btn signup">
              تسجيل الخروج
            </button>
          </>
        );
    }
  };

  return (
    <>
      <section className={`head ${darkMode ? "dark" : ""}`}>
        <div className="container flexSB">

          {/* 🔥 LOGO */}
          <div className="left-logo" onClick={() => navigate("/")}>
            <img src="/images/Loogo.png" alt="Logo" className="logo-img" />
            <span>الرئيسيه</span>
          </div>

          {/* 🔥 DESKTOP */}
          <div className="buttons desktop">
            <button onClick={toggleDarkMode} className="btn darkmode">
              {darkMode ? "☀️" : "🌙"}
            </button>

            {renderButtons()}
          </div>

          {/* 🔥 MOBILE DARK/LIGHT BUTTON */}
          <div className="mobile-darkmode">
            <button onClick={toggleDarkMode} className="btn darkmode">
              {darkMode ? "☀️" : "🌙"}
            </button>
          </div>

          {/* 🔥 MOBILE ICON */}
          <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* 🔥 MOBILE MENU */}
        <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
          {renderButtons()}
        </div>
      </section>

      <ScrollProgressBar />
    </>
  );
};

export default Head;